import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import ConfirmAppointment from "@/pages/ConfirmAppointment";
import ClientPresence from "@/pages/ClientPresence";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/rdv/:token" element={<ConfirmAppointment />} />
          <Route path="/presence/:token" element={<ClientPresence />} />
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
